// src/utils/encryptUtils.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'your-very-secure-key'; // use environment variable in real apps

export const encryptId = (id) => {
  return CryptoJS.AES.encrypt(id, SECRET_KEY).toString();
};

export const decryptId = (encryptedId) => {
  const bytes = CryptoJS.AES.decrypt(encryptedId, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
